import { AfterContentInit, Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { AuthService } from '../service/auth.service';

@Component({
  selector: 'app-admin-translations',
  standalone: false,
  templateUrl: './admin-translations.component.html',
  styleUrl: './admin-translations.component.css'
})
export class AdminTranslationsComponent {
  errMessage = "";
  successMessage = "";
  authToken = localStorage.getItem('auth');
  translations = [];
  users = [];
  add_form: FormGroup;
  edit_form: FormGroup;
  messageErr;
  pub = 0
  priv = 0;
  currentTranslation;
  isLoading = false;

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json', 'auth': `${this.authToken}` }),
    withCredentials: true,
  };


  constructor(
    private router: Router,
    private fb: FormBuilder,
    private http: HttpClient,
    private route: ActivatedRoute,
    private authService: AuthService) {
  }


  ngOnInit(): void {
    this.fetchTranslations();
    this.initForms();

  }

  get add_key() { return this.add_form.get('a_key') };
  get add_fi() { return this.add_form.get('a_fi') };
  get add_en() { return this.add_form.get('a_en') };
  get add_sv() { return this.add_form.get('a_sv') };

  get edit_key() { return this.edit_form.get('e_key') };
  get edit_fi() { return this.edit_form.get('e_fi') };
  get edit_en() { return this.edit_form.get('e_en') };
  get edit_sv() { return this.edit_form.get('e_sv') };


  initForms() {
    this.add_form = this.fb.group({
      a_key: ['', [
        Validators.required,
      ]],
      a_fi: ['', [
        Validators.required,
      ]],
      a_en: ['', [
        Validators.required,
      ]],
      a_sv: ['', [
        Validators.required,
      ]],
    });

    this.edit_form = this.fb.group({
      e_key: ['', [
        Validators.required,
      ]],
      e_fi: ['', [
        Validators.required,
      ]],
      e_en: ['', [
        Validators.required,
      ]],
     e_sv: ['', [
        Validators.required,
      ]],
    });
  }

  fetchTranslations() {

    this.http.get(environment.FETCH_TRANSLATIONS, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          this.translations = res.message;

        }
        else {
          console.log('ei ole kyseistä käyttäjää')
        }

      }, (err: any) => {

        console.log("Error while finding status :: ", err);
      })


  }

  editTranslation(data) {
    console.log(data);
    this.currentTranslation = data;

    //Set values to edit form
    this.edit_key.setValue(data.key);
    this.edit_fi.setValue(data.fi);
    this.edit_en.setValue(data.en);
    this.edit_sv.setValue(data.sv);


  }

  onSubmit(){
    if(this.currentTranslation){
      this.updateTranslation();
    }
    else{
      this.addTranslation();
    }
  }

  addTranslation() {
    this.isLoading = true;
    var req = {
      key: this.add_key.value,
      fi: this.add_fi.value,
      en: this.add_en.value,
      sv: this.add_sv.value
    }
    console.log(req);
    this.http.post(environment.TRANSLATION, req, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          this.successMessage = "Translation added successfully";
          this.fetchTranslations();
          this.isLoading = false;
          this.add_form.reset();
        }
        else {
          this.errMessage = res.message;
          this.isLoading = false;
        }

      }, (err: any) => {

        console.log("Error while finding status :: ", err);
      })
  }

  updateTranslation() {
    this.isLoading = true;
    var req = {
      key: this.edit_key.value,
      fi: this.edit_fi.value,
      en: this.edit_en.value,
      sv: this.edit_sv.value,
      _id: this.currentTranslation._id
    }
    this.http.put(environment.TRANSLATION, req, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200) {
          this.successMessage = "Translation updated successfully";
          this.fetchTranslations();
          this.isLoading = false;
          this.edit_form.reset();
          this.currentTranslation = null;
          document.getElementById('close_edit').click();
        }
        else {
          this.errMessage = res.message;
          this.isLoading = false;
        }

      }, (err: any) => {

        console.log("Error while finding status :: ", err);
      })
  }

  fetchTest(){
    this.http.post(environment.TRANS_TEST, {}, this.httpOptions).subscribe(
      (res: any) => {
        if (res.status == 200)
          console.log(res.message);
        else {
          console.log('ei ole kyseistä käyttäjää')
        }
      }, (err: any) => {

        console.log("Error while finding status :: ", err);
      })
  }


}


